import React from 'react';

const Header = ({ toggleSidebar }) => {
  return (
    <header className="header">
      <div>
        <h1>🚀 WhakUp API - Documentation</h1>
      </div>
      <div className="header-actions">
        <button className="btn-toggle" onClick={toggleSidebar}>
          ☰ Menu
        </button>
        <span style={{ fontSize: '0.9rem', opacity: 0.9 }}>v2.0</span>
      </div>
    </header>
  );
};

export default Header;
